<template>
    <div v-if="showCriticalModal && $store.getters.hasGatehousePerm('view_notification')" class="critical_modal_backdrop">
        <div class="critical_modal">
            <h2 class="text-danger fw-bold">{{ $t("notifications.modalTitle") }}</h2>

            <ul v-if="criticalNotifications.length > 0" class="list-unstyled text-start mt-3">
                <li v-for="notification in criticalNotifications"
                    :key="notification.id"
                    class="mb-3 p-3 border rounded bg-light">

                    <div class="fw-bold mb-1">
                        {{ getNotificationMessage(notification) }}
                    </div>
                    <div>
                        {{ $t("gatehouse.label") }}: <strong>{{ notification.gatehouse_name }}</strong><br>
                    </div>
                    <div>
                        {{ $t("notifications.device") }}: <strong>{{ notification.device_name }}</strong><br>
                    </div>
                    <div>
                        {{ $t("notifications.created") }}: <strong>{{ notification.created_at ? $d(new Date(notification.created_at), "short") : "-" }}</strong>
                    </div>

                    <div class="text-end mt-2">
                        <button class="btn btn-primary btn-sm"
                            @click="openEvent(notification)">
                            {{ $t("utils.open") }}
                        </button>
                    </div>
                </li>
            </ul>

            <div class="text-end mt-4">
                <button class="btn btn-danger" @click="showCriticalModal = false">
                    {{ $t("utils.close") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            intervalId: null,
            showCriticalModal: false,
            criticalNotifications: [],
        }
    },
    computed: {
        selectedGatehouse() {
            return this.$store.getters.selectedGatehouse;
        },
        currentSlug() {
            return this.$route.params.slug || null;
        }
    },
    mounted() {
        this.startPolling();
    },
    beforeUnmount() {
        clearInterval(this.intervalId);
    },
    methods: {
        fetchData() {
            if (!this.$store.getters.hasGatehousePerm('view_notification')) {
                return;
            }

            const api = this.$store.getters.api;

            api.get(`/dashboard/${this.currentSlug}/notifications/critical-global`)
                .then(res => {
                    if (res.data.critical) {
                        this.criticalNotifications = res.data.notifications;
                        this.showCriticalModal = true;
                    } else {
                        this.criticalNotifications = [];
                        this.showCriticalModal = false;
                    }
                })
                .catch(error => {
                    console.error("Error loading critical notifications", error);
                });

                api.get(`/dashboard/${this.currentSlug}/notifications/unresolved-count`)
                .then(res => {
                    const newCount = res.data.count;
                    const oldCount = this.$store.state.lastNotificationCount;

                    if (newCount !== oldCount) {
                        this.$store.commit("setNotificationCount", newCount);
                        this.$store.state.lastNotificationCount = newCount;
                    }
                });
        },
        startPolling() {
            this.fetchData();
            this.intervalId = setInterval(this.fetchData, 10000);
        },
        openEvent(notification) {
            this.showCriticalModal = false;
            this.$router.push(`/dashboard/${notification.gatehouse_slug}/notifications`);
        },
        getNotificationMessage(notification){
            const { type, level, data, device_name} = notification;

            if (type === "battery_low") {
                const levelKey =
                    level === "critical"
                        ? "messageCritical"
                        : "messageWarning"

                return this.$t(`notifications.battery.${levelKey}`, {
                    device: device_name,
                    battery: data.battery_level
                })
            }

            if (type === "fall_detected") {
                return this.$t(`notifications.fall.message`, {
                    device: device_name,
                })
            }
        }
    },
    watch: {
        currentSlug(newSlug, oldSlug) {
            if (!oldSlug) return;
            this.fetchData();
        }
    }
}
</script>

<style scoped>
.critical_modal_backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.critical_modal {
    background: white;
    padding: 40px;
    border-radius: 15px;
    width: 500px;
    text-align: center;
    animation: pulseBorder 1s infinite;
}

@keyframes pulseBorder {
    0%   { box-shadow: 0 0 0 0 rgba(220,53,69,0.8); }
    100% { box-shadow: 0 0 70px 40px rgba(220,53,69,0); }
}
</style>